export default {
  title: 'Pasarelas de pago',
  fields: {
    name: 'Nombre',
    payment_gateway: 'Pasarelas de pago',
    live_from: 'Activo desde',
    last_30_days_sales: 'Ventas últimos 30 días',
    kyc_deadlines: 'Plazos KYC',
    actions: 'Acciones',
  },
  stats: {
    active_on_stripe: 'Activo en Stripe',
    active_on_adyen: 'Activo en Adyen',
    adyen_verification_pending: 'Verificación de Adyen pendiente',
  },
  filters: {
    search_placeholder: 'Buscar por nombre...',
    gateway_status_placeholder: 'Todas las pasarelas',
  },
  not_configured: {
    title: 'Los pagos aún no están configurados',
    description:
      'No hay ningún proveedor de pago conectado a tu cuenta. Los restaurantes pueden configurarse completamente, pero no pueden activarse ni aceptar pagos en línea hasta que se configuren los pagos.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (Pendiente)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verificado',
    pending: 'Pendiente',
    rejected: 'Rechazado',
  },
  buttons: {
    actions: 'Acciones',
    switch_to: 'Cambiar a {{gateway}}',
    view_details: 'Ver detalles',
    open_onboarding: 'Abrir incorporación',
    create_onboarding_link: 'Crear enlace de incorporación',
  },
  modal: {
    title: 'Cambiar pasarela de pago',
    description:
      '¿Seguro que quieres cambiar {{companyName}} de <bold>{{currentGateway}}</bold> a <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      '{{gateway}} no está verificado para esta empresa. El procesamiento de pagos puede verse afectado.',
    confirm: 'Cambiar',
    cancel: 'Cancelar',
  },
  details_modal: {
    title: '{{companyName}} — Detalles de la pasarela de pago',
    requirements: 'Requisitos',
    no_requirements: 'Sin requisitos pendientes.',
    deadline: 'Fecha límite',
    capabilities: 'Capacidades',
    onboarding_links: {
      section_title: 'Enlace de incorporación',
      active_link: 'Enlace activo',
      expires: 'Vence {{date}}',
      create_button: 'Crear enlace',
      extend_button: 'Extender enlace',
      loading: 'Cargando enlaces…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Error al crear el enlace de incorporación.',
    switch_success: 'Pasarela de pago cambiada correctamente.',
    switch_failed: 'Error al cambiar la pasarela de pago.',
    failed_to_load_data: 'Error al cargar los datos.',
  },
};
